// Mock data for Diane Neill Photography Portfolio

export const portfolioImages = {
  concerts: [
    { id: 'c1', url: '/assets/live_music/AA2_6987.jpg', title: 'AA2 6987', category: 'concerts' },
    { id: 'c2', url: '/assets/live_music/AK_4868c.jpg', title: 'AK 4868c', category: 'concerts' },
    { id: 'c3', url: '/assets/live_music/AK_5856.jpg', title: 'AK 5856', category: 'concerts' },
    { id: 'c4', url: '/assets/live_music/AK_5863.jpg', title: 'AK 5863', category: 'concerts' },
    { id: 'c5', url: '/assets/live_music/CD_0200.jpg', title: 'CD 0200', category: 'concerts' },
    { id: 'c6', url: '/assets/live_music/CD_0203.jpg', title: 'CD 0203', category: 'concerts' },
    { id: 'c7', url: '/assets/live_music/CD_0205.jpg', title: 'CD 0205', category: 'concerts' },
    { id: 'c8', url: '/assets/live_music/CD_192.jpg', title: 'CD 192', category: 'concerts' },
    { id: 'c9', url: '/assets/live_music/CU_%20027c.jpg', title: 'CU 027c', category: 'concerts' },
    { id: 'c10', url: '/assets/live_music/CU_%20033c.jpg', title: 'CU 033c', category: 'concerts' },
    { id: 'c11', url: '/assets/live_music/CU_%20152%20c.jpg', title: 'CU 152c', category: 'concerts' },
    { id: 'c12', url: '/assets/live_music/Di_1733.jpg', title: 'Di 1733', category: 'concerts' },
    { id: 'c13', url: '/assets/live_music/Di_7258.jpg', title: 'Di 7258', category: 'concerts' },
    { id: 'c14', url: '/assets/live_music/Di_9206.jpg', title: 'Di 9206', category: 'concerts' },
    { id: 'c15', url: '/assets/live_music/Di_9212.jpg', title: 'Di 9212', category: 'concerts' },
    { id: 'c16', url: '/assets/live_music/Di_9227.jpg', title: 'Di 9227', category: 'concerts' },
    { id: 'c17', url: '/assets/live_music/EH_019.jpg', title: 'EH 019', category: 'concerts' },
    { id: 'c18', url: '/assets/live_music/EH_022.jpg', title: 'EH 022', category: 'concerts' },
    { id: 'c19', url: '/assets/live_music/EH_032.jpg', title: 'EH 032', category: 'concerts' },
    { id: 'c20', url: '/assets/live_music/EH_035.jpg', title: 'EH 035', category: 'concerts' },
    { id: 'c21', url: '/assets/live_music/GB_599.jpg', title: 'GB 599', category: 'concerts' },
    { id: 'c22', url: '/assets/live_music/GB_613.jpg', title: 'GB 613', category: 'concerts' },
    { id: 'c23', url: '/assets/live_music/GB_628.jpg', title: 'GB 628', category: 'concerts' },
    { id: 'c24', url: '/assets/live_music/JA%201008%20cc.jpg', title: 'JA 1008', category: 'concerts' },
    { id: 'c25', url: '/assets/live_music/JA%201018%20cc.jpg', title: 'JA 1018', category: 'concerts' },
    { id: 'c26', url: '/assets/live_music/JA%201087%20cc.jpg', title: 'JA 1087', category: 'concerts' },
    { id: 'c27', url: '/assets/live_music/JM_9533.jpg', title: 'JM 9533', category: 'concerts' },
    { id: 'c28', url: '/assets/live_music/JM_9555.jpg', title: 'JM 9555', category: 'concerts' },
    { id: 'c29', url: '/assets/live_music/JM_9634.jpg', title: 'JM 9634', category: 'concerts' },
    { id: 'c30', url: '/assets/live_music/JM_9635.jpg', title: 'JM 9635', category: 'concerts' },
    { id: 'c31', url: '/assets/live_music/JM_9671.jpg', title: 'JM 9671', category: 'concerts' },
    { id: 'c32', url: '/assets/live_music/LR_4953.jpg', title: 'LR 4953', category: 'concerts' },
    { id: 'c33', url: '/assets/live_music/LR_952ab.jpg', title: 'LR 952ab', category: 'concerts' },
    { id: 'c34', url: '/assets/live_music/ME_6733%20a.JPG', title: 'ME 6733', category: 'concerts' },
    { id: 'c35', url: '/assets/live_music/ME_6842%20wbandmates.JPG', title: 'ME 6842 Bandmates', category: 'concerts' },
    { id: 'c36', url: '/assets/live_music/ME_727%20bal.jpg', title: 'ME 727', category: 'concerts' },
    { id: 'c37', url: '/assets/live_music/ME_736%20.jpg', title: 'ME 736', category: 'concerts' },
    { id: 'c38', url: '/assets/live_music/MU_101.jpg', title: 'MU 101', category: 'concerts' },
    { id: 'c39', url: '/assets/live_music/MU_244.jpg', title: 'MU 244', category: 'concerts' },
    { id: 'c40', url: '/assets/live_music/MU_257.jpg', title: 'MU 257', category: 'concerts' },
    { id: 'c41', url: '/assets/live_music/MU_432.jpg', title: 'MU 432', category: 'concerts' },
    { id: 'c42', url: '/assets/live_music/MU_444.jpg', title: 'MU 444', category: 'concerts' },
    { id: 'c43', url: '/assets/live_music/MU_460.jpg', title: 'MU 460', category: 'concerts' },
    { id: 'c44', url: '/assets/live_music/MU_499a.jpg', title: 'MU 499a', category: 'concerts' }
  ],
  portraits: [
    { id: 'p1', url: '/assets/portrait/Po_01.jpg', title: 'Po 01', category: 'portraits' },
    { id: 'p2', url: '/assets/portrait/Po_02.jpg', title: 'Po 02', category: 'portraits' },
    { id: 'p3', url: '/assets/portrait/Po_03.jpg', title: 'Po 03', category: 'portraits' },
    { id: 'p4', url: '/assets/portrait/Po_08.jpg', title: 'Po 08', category: 'portraits' },
    { id: 'p5', url: '/assets/portrait/Po_09.jpg', title: 'Po 09', category: 'portraits' },
    { id: 'p6', url: '/assets/portrait/Po_10.jpg', title: 'Po 10', category: 'portraits' },
    { id: 'p7', url: '/assets/portrait/Po_24.jpg', title: 'Po 24', category: 'portraits' },
    { id: 'p8', url: '/assets/portrait/Po_25.jpg', title: 'Po 25', category: 'portraits' },
    { id: 'p9', url: '/assets/portrait/Po_30.jpg', title: 'Po 30', category: 'portraits' },
    { id: 'p10', url: '/assets/portrait/Po_31.jpg', title: 'Po 31', category: 'portraits' },
    { id: 'p11', url: '/assets/portrait/HsS_02.jpg', title: 'HsS 02', category: 'portraits' },
    { id: 'p12', url: '/assets/portrait/HsS%20_10.jpg', title: 'HsS 10', category: 'portraits' },
    { id: 'p13', url: '/assets/portrait/HsS%20_11.jpg', title: 'HsS 11', category: 'portraits' },
    { id: 'p14', url: '/assets/portrait/HsS_12.jpg', title: 'HsS 12', category: 'portraits' },
    { id: 'p15', url: '/assets/portrait/HsS_13.jpg', title: 'HsS 13', category: 'portraits' },
    { id: 'p16', url: '/assets/portrait/HsS_16.jpg', title: 'HsS 16', category: 'portraits' },
    { id: 'p17', url: '/assets/portrait/Ma_01.jpg', title: 'Ma 01', category: 'portraits' },
    { id: 'p18', url: '/assets/portrait/Mu_12.jpg', title: 'Mu 12', category: 'portraits' }
  ],
  childrenPets: [
    { id: 'cp1', url: '/assets/children_and_pets/Ch_01.jpg', title: 'Ch 01', category: 'childrenPets' },
    { id: 'cp2', url: '/assets/children_and_pets/Ch_02.jpg', title: 'Ch 02', category: 'childrenPets' },
    { id: 'cp3', url: '/assets/children_and_pets/Ch_03.jpg', title: 'Ch 03', category: 'childrenPets' },
    { id: 'cp4', url: '/assets/children_and_pets/Ch_04.jpg', title: 'Ch 04', category: 'childrenPets' },
    { id: 'cp5', url: '/assets/children_and_pets/Ch_05.jpg', title: 'Ch 05', category: 'childrenPets' },
    { id: 'cp6', url: '/assets/children_and_pets/Ch_08.jpg', title: 'Ch 08', category: 'childrenPets' },
    { id: 'cp7', url: '/assets/children_and_pets/Ch_09.jpg', title: 'Ch 09', category: 'childrenPets' },
    { id: 'cp8', url: '/assets/children_and_pets/Ch_10.jpg', title: 'Ch 10', category: 'childrenPets' },
    { id: 'cp9', url: '/assets/children_and_pets/Ch_16.jpg', title: 'Ch 16', category: 'childrenPets' },
    { id: 'cp10', url: '/assets/children_and_pets/Ch_20.jpg', title: 'Ch 20', category: 'childrenPets' },
    { id: 'cp11', url: '/assets/children_and_pets/Ch_21.jpg', title: 'Ch 21', category: 'childrenPets' },
    { id: 'cp12', url: '/assets/children_and_pets/Ch_23.jpg', title: 'Ch 23', category: 'childrenPets' },
    { id: 'cp13', url: '/assets/children_and_pets/Ch_23a.jpg', title: 'Ch 23a', category: 'childrenPets' },
    { id: 'cp14', url: '/assets/children_and_pets/Ch_23b.jpg', title: 'Ch 23b', category: 'childrenPets' },
    { id: 'cp15', url: '/assets/children_and_pets/Ch_24.jpg', title: 'Ch 24', category: 'childrenPets' },
    { id: 'cp16', url: '/assets/children_and_pets/Ch_25.jpg', title: 'Ch 25', category: 'childrenPets' },
    { id: 'cp17', url: '/assets/children_and_pets/Ch_26.jpg', title: 'Ch 26', category: 'childrenPets' },
    { id: 'cp18', url: '/assets/children_and_pets/Ch_27.jpg', title: 'Ch 27', category: 'childrenPets' },
    { id: 'cp19', url: '/assets/children_and_pets/Ch_29a.jpg', title: 'Ch 29a', category: 'childrenPets' },
    { id: 'cp20', url: '/assets/children_and_pets/Ch_32.jpg', title: 'Ch 32', category: 'childrenPets' },
    { id: 'cp21', url: '/assets/children_and_pets/Pt_01.jpg', title: 'Pt 01', category: 'childrenPets' },
    { id: 'cp22', url: '/assets/children_and_pets/Pt_02a.jpg', title: 'Pt 02a', category: 'childrenPets' },
    { id: 'cp23', url: '/assets/children_and_pets/Pt_146.jpg', title: 'Pt 146', category: 'childrenPets' },
    { id: 'cp24', url: '/assets/children_and_pets/Pt_146a.jpg', title: 'Pt 146a', category: 'childrenPets' },
    { id: 'cp25', url: '/assets/children_and_pets/Pt_31a.jpg', title: 'Pt 31a', category: 'childrenPets' },
    { id: 'cp26', url: '/assets/children_and_pets/Pt_32.jpg', title: 'Pt 32', category: 'childrenPets' },
    { id: 'cp27', url: '/assets/children_and_pets/Pt_32a.jpg', title: 'Pt 32a', category: 'childrenPets' },
    { id: 'cp28', url: '/assets/children_and_pets/Pt_33.jpg', title: 'Pt 33', category: 'childrenPets' },
    { id: 'cp29', url: '/assets/children_and_pets/Pt_34.jpg', title: 'Pt 34', category: 'childrenPets' },
    { id: 'cp30', url: '/assets/children_and_pets/Pt_42a.jpg', title: 'Pt 42a', category: 'childrenPets' }
  ],
  sportsDance: [
    { id: 'sd1', url: '/assets/sports_dance/Sp_%2001.jpg', title: 'Sp 01', category: 'sportsDance' },
    { id: 'sd2', url: '/assets/sports_dance/Sp_%2002.jpg', title: 'Sp 02', category: 'sportsDance' },
    { id: 'sd3', url: '/assets/sports_dance/Sp_03.jpg', title: 'Sp 03', category: 'sportsDance' },
    { id: 'sd4', url: '/assets/sports_dance/Sp_04.jpg', title: 'Sp 04', category: 'sportsDance' },
    { id: 'sd5', url: '/assets/sports_dance/Sp_05.jpg', title: 'Sp 05', category: 'sportsDance' },
    { id: 'sd6', url: '/assets/sports_dance/Sp_06.jpg', title: 'Sp 06', category: 'sportsDance' },
    { id: 'sd7', url: '/assets/sports_dance/Sp_07.jpg', title: 'Sp 07', category: 'sportsDance' },
    { id: 'sd8', url: '/assets/sports_dance/Sp_08.jpg', title: 'Sp 08', category: 'sportsDance' },
    { id: 'sd9', url: '/assets/sports_dance/Sp_09a.jpg', title: 'Sp 09a', category: 'sportsDance' },
    { id: 'sd10', url: '/assets/sports_dance/Sp_10.jpg', title: 'Sp 10', category: 'sportsDance' },
    { id: 'sd11', url: '/assets/sports_dance/Sp_10a.jpg', title: 'Sp 10a', category: 'sportsDance' },
    { id: 'sd12', url: '/assets/sports_dance/Sp_11.jpg', title: 'Sp 11', category: 'sportsDance' },
    { id: 'sd13', url: '/assets/sports_dance/Sp_12.jpg', title: 'Sp 12', category: 'sportsDance' },
    { id: 'sd14', url: '/assets/sports_dance/Sp_36.jpg', title: 'Sp 36', category: 'sportsDance' },
    { id: 'sd15', url: '/assets/sports_dance/Sp_37.jpg', title: 'Sp 37', category: 'sportsDance' },
    { id: 'sd16', url: '/assets/sports_dance/Sp_38.jpg', title: 'Sp 38', category: 'sportsDance' },
    { id: 'sd17', url: '/assets/sports_dance/Sp_42.jpg', title: 'Sp 42', category: 'sportsDance' },
    { id: 'sd18', url: '/assets/sports_dance/Dn_13.jpg', title: 'Dn 13', category: 'sportsDance' },
    { id: 'sd19', url: '/assets/sports_dance/Dn_14.jpg', title: 'Dn 14', category: 'sportsDance' },
    { id: 'sd20', url: '/assets/sports_dance/Dn_14a.jpg', title: 'Dn 14a', category: 'sportsDance' },
    { id: 'sd21', url: '/assets/sports_dance/Dn_15.jpg', title: 'Dn 15', category: 'sportsDance' },
    { id: 'sd22', url: '/assets/sports_dance/Dn_22.jpg', title: 'Dn 22', category: 'sportsDance' },
    { id: 'sd23', url: '/assets/sports_dance/Dn_23.jpg', title: 'Dn 23', category: 'sportsDance' },
    { id: 'sd24', url: '/assets/sports_dance/Dn_60.jpg', title: 'Dn 60', category: 'sportsDance' },
    { id: 'sd25', url: '/assets/sports_dance/Dn_61.jpg', title: 'Dn 61', category: 'sportsDance' },
    { id: 'sd26', url: '/assets/sports_dance/Dn_62.jpg', title: 'Dn 62', category: 'sportsDance' },
    { id: 'sd27', url: '/assets/sports_dance/Dn_63a.jpg', title: 'Dn 63a', category: 'sportsDance' }
  ],
  weddings: [
    { id: 'w1', url: '/assets/wedding/Wdd%2001.jpg', title: 'Wdd 01', category: 'weddings' },
    { id: 'w2', url: '/assets/wedding/Wdd%2002.jpg', title: 'Wdd 02', category: 'weddings' },
    { id: 'w3', url: '/assets/wedding/Wdd%2003.jpg', title: 'Wdd 03', category: 'weddings' },
    { id: 'w4', url: '/assets/wedding/Wdd%2004.jpg', title: 'Wdd 04', category: 'weddings' },
    { id: 'w5', url: '/assets/wedding/Wdd%2007.jpg', title: 'Wdd 07', category: 'weddings' },
    { id: 'w6', url: '/assets/wedding/Wdd%2009.jpg', title: 'Wdd 09', category: 'weddings' },
    { id: 'w7', url: '/assets/wedding/Wdd%2010.jpg', title: 'Wdd 10', category: 'weddings' },
    { id: 'w8', url: '/assets/wedding/Wdd%2012.jpg', title: 'Wdd 12', category: 'weddings' },
    { id: 'w9', url: '/assets/wedding/Wdd%2012a.jpg', title: 'Wdd 12a', category: 'weddings' },
    { id: 'w10', url: '/assets/wedding/Wdd%2013.jpg', title: 'Wdd 13', category: 'weddings' },
    { id: 'w11', url: '/assets/wedding/Wdd%2016.jpg', title: 'Wdd 16', category: 'weddings' },
    { id: 'w12', url: '/assets/wedding/Wdd%2016b.jpg', title: 'Wdd 16b', category: 'weddings' },
    { id: 'w13', url: '/assets/wedding/Wdd%2019.jpg', title: 'Wdd 19', category: 'weddings' },
    { id: 'w14', url: '/assets/wedding/Wdd%2020.jpg', title: 'Wdd 20', category: 'weddings' },
    { id: 'w15', url: '/assets/wedding/Wdd%2023.jpg', title: 'Wdd 23', category: 'weddings' },
    { id: 'w16', url: '/assets/wedding/Wdd%2024.jpg', title: 'Wdd 24', category: 'weddings' },
    { id: 'w17', url: '/assets/wedding/Wdd%2025.jpg', title: 'Wdd 25', category: 'weddings' },
    { id: 'w18', url: '/assets/wedding/Wdd%2027.jpg', title: 'Wdd 27', category: 'weddings' }
  ]
};

export const aboutContent = {
  title: "In Diane's Own Words",
  bio: `My Photographic Professional Career started as a Public Relations Assistant in Boston, MA photographing Events. I then worked on both Coasts for a National Portrait Studio photographing Children and Families. I have also worked for a Magazine Publisher and a local Newspaper Publisher as a Photojournalist and Reporter. Geographically, I have had the fortunate experience of working photographically, throughout New England, California, Arizona, New Mexico, Tennessee and Kentucky.

I have been formally educated and hold a Bachelor of Fine Arts in English/Creative Writing, an Associate of Science in Journalism and (2) Certificate of Photography Degrees.

For over 30 years, Portraits by Neill has provided photographs creating memories for my clients, to last a lifetime.

My photographic work has encompassed Live Music, Weddings, Children, Families, Pets, Special Occasions, High School Seniors, Dance and Sporting Events.

Long before I started my Portrait and Wedding business, my love for photography began from attending Live Concerts!

These days, my photographic concentration is primarily in the public domain of photographing Concerts.

I am available for sessions that may include live Performances, Practice Sessions, Promo Shots... I am available to travel throughout New England or anywhere else in the world.`,
  stats: {
    experience: '30+ years',
    concerts: '200+',
    clients: '300+'
  }
};

export const contactInfo = {
  phone: '+1 (413)323-0500',
  email: 'info@portraitsbyneill.com',
  facebook: 'https://www.facebook.com/PortraitsByNeill',
  instagram: 'https://www.instagram.com/portraitsbyneill/',
  businessHours: {
    weekdays: 'Monday - Friday: 9:00 AM - 6:00 PM',
    saturday: 'Saturday: By Appointment',
    sunday: 'Sunday: By Appointment'
  }
};

export const testimonials = [
  {
    id: 1,
    text: "Thank you very much for all your hard work to make our Wedding such a great day to remember.",
    author: "Joanne and John",
    role: ""
  },
  {
    id: 2,
    text: "When I look at the photos you took for me, I am brought back to the moment they were taken and can relive the joy of that special day! Thank you for being there to capture this for me.",
    author: "Karen",
    role: ""
  },
  {
    id: 3,
    text: "Thank you for being a fantastic Photographer. We appreciate everything you did to capture our Wedding day.",
    author: "Keith and Therese",
    role: ""
  },
  {
    id: 4,
    text: "We can't thank you enough. From the initial photos of our Wedding to the current ones you've taken of our daughters, you always have a knack for capturing the best smiles. Some of the black and white images have become our favorites. And the fact that the girls always enjoy having their photos taken is one more reason I always have nice albums to show for it!",
    author: "K. K. and Daughters",
    role: ""
  },
  {
    id: 5,
    text: "Thank you for the beautiful photos. We love them!",
    author: "Linda, Steve and Family",
    role: ""
  }
];

export const services = [
  {
    id: 1,
    title: 'Concert Photography',
    description: 'Dynamic, high-energy concert photography that captures the raw emotion and electric atmosphere of live performances. From intimate venues to festival stages.',
    category: 'specialty',
    image: '/assets/live_music/Di_9206.jpg'
  },
  {
    id: 2,
    title: 'Music Events & Festivals',
    description: 'Comprehensive coverage of music festivals and events, capturing the energy, crowd, and unforgettable moments of live music experiences.',
    category: 'specialty',
    image: '/assets/live_music/GB_613.jpg'
  },
  {
    id: 3,
    title: 'Band Promotion Photos',
    description: 'Professional band and artist photography for promotional materials, album covers, and press kits that capture your unique sound visually.',
    category: 'additional',
    image: '/assets/live_music/LR_4953.jpg'
  },
  {
    id: 4,
    title: 'Artist Headshots',
    description: 'Professional headshots for musicians and performers that showcase personality and stage presence for press materials and social media.',
    category: 'additional',
    image: '/assets/portrait/Po_25.jpg'
  },
  {
    id: 5,
    title: 'Wedding Photography',
    description: 'Beautiful, timeless wedding photography with a photojournalistic approach, capturing authentic moments and emotions throughout your special day.',
    category: 'additional',
    image: '/assets/wedding/Wdd%2001.jpg'
  },
  {
    id: 6,
    title: 'Event Photography',
    description: 'Professional event coverage for corporate functions, private parties, and special occasions with attention to detail and storytelling.',
    category: 'additional',
    image: '/assets/sports_dance/Dn_22.jpg'
  }
];
